import endpoints from 'shared/store/endpoints'
import { ws } from 'shared/store/ws'
import type { Dispatch } from 'redux'
import type { RootState } from 'shared/store/reducers'
import type { ActionsNetwork } from 'shared/store/actions'
import { getUrlParams as urlParams } from 'shared/utils/ecommerce/utils'
import { signInSuccess } from 'shared/store/signin'

type GetState = () => RootState

type ActionCongratulationsPageDataSuccess = {
    type: 'PAGE_DATA_CONGRATULATIONS_SUCCESS',
    signType?: string
}

type ActionCongratulationsError = {
    type: 'CONGRATULATIONS_ERROR',
    data: {
        activateError: any
    }
}

type ActionCongratulationsResendMailError = {
    type: 'CONGRATULATIONS_RESEND_MAIL_ERROR',
    resendMailError: any
}

type ActionCongratulationsPathError = {
    type: 'CONGRATULATIONS_PATH_ERROR'
}

type ActionCongratulationsResendMailSuccess = {
    type: 'CONGRATULATIONS_RESEND_MAIL_SUCCESS'
}

const getUrlParams = () => {
    return async (dispatch: Dispatch<any>, getState: GetState) => {
        const search = getState().router.location.search
        const params = urlParams(search)
        if (!params['token']) {
            console.error(
                'URL has invalid paramaters: token query parameters not found !'
            )
            dispatch(actionCongratulationsPathError())
        } else {
            const token = params['token']
            const signType = params['sign_type']
            return await dispatch(activateAccount(token, signType))
        }
    }
}

const activateAccount = (token: string, signType?: string) => {
    return async (dispatch: Dispatch<any>) => {
        if (!token) {
            console.error('URL is invalid: token not found !')
            dispatch(actionCongratulationsPathError())
        } else {
            try {
                //$FlowFixMe
                const response = await ws.get(
                    endpoints.kingdom.congratulations,
                    {
                        params: { token: token, autoLogin: true }
                    }
                )
                if (response && response.headers['authorization']) {
                    dispatch(
                        signInSuccess({
                            headers: response.headers,
                            fromEcommerce: false
                        })
                    )
                }
                dispatch(activateAccountSuccess(signType))
                return true
            } catch (error) {
                console.error('Error activating account', error)
                dispatch(activateAccountError(error))
            }
        }
    }
}

const actionCongratulationsPathError = (): ActionCongratulationsPathError => ({
    type: 'CONGRATULATIONS_PATH_ERROR'
})

const resendMail = (queen: string) => {
    return async (dispatch: Dispatch<any>, getState: GetState) => {
        const { email } = getState().congratulationsPageState
        try {
            await ws.get(endpoints.kingdom.activate, {
                params: { email: email, queen: queen }
            })
            dispatch(actionResendMailSuccess())
        } catch (error) {
            console.error('Error resending activation email :', error)
            dispatch(actionResendMailError(error))
        }
    }
}

const activateAccountSuccess = (
    signType?: string
): ActionCongratulationsPageDataSuccess => ({
    type: 'PAGE_DATA_CONGRATULATIONS_SUCCESS',
    signType
})

const activateAccountError = (
    activateError: any
): ActionCongratulationsError => ({
    type: 'CONGRATULATIONS_ERROR',
    data: { activateError: activateError }
})

const actionResendMailSuccess = (): ActionCongratulationsResendMailSuccess => ({
    type: 'CONGRATULATIONS_RESEND_MAIL_SUCCESS'
})

const actionResendMailError = (
    resendMailError: any
): ActionCongratulationsResendMailError => ({
    type: 'CONGRATULATIONS_RESEND_MAIL_ERROR',
    resendMailError
})

export { activateAccount, getUrlParams, resendMail }

export type Action =
    | ActionCongratulationsPageDataSuccess
    | ActionCongratulationsPathError
    | ActionCongratulationsError
    | ActionCongratulationsResendMailSuccess
    | ActionCongratulationsResendMailError
    | ActionsNetwork
